<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import Swal from "sweetalert2";
import Jefe from "../../views/evaluaciones/evaluacion-jefedepartamento";
import Profesor from "../../views/evaluaciones/evaluacion-profesorjefe";
import Encargado from "../../views/evaluaciones/evaluacion-encargadoconvivencia";
import Docente from "../../views/evaluaciones/evaluacion-docente";
import Coordinador from "../../views/evaluaciones/evaluacion-coordinadoracademico";
import Auxiliar from "../../views/evaluaciones/evaluacion-auxiliar";
import Asistente from "../../views/evaluaciones/evaluacion-asistenteeducacion";
/**
 * Starter component
 */
export default {
    components: { Layout, PageHeader, Jefe, Profesor, Encargado, Docente, Coordinador, Auxiliar, Asistente },
    data() {
        return {
            title: "Retroalimentación",
            items: [
                {
                text: "Utility",
                href: "/"
                },
                {
                text: "Starter Page",
                active: true
                }
            ],
            usuarios:[],
            totalRows: 1,
            currentPage: 1,
            perPage: 10,
            pageOptions: [10, 25, 50, 100],
            filter: null,
            filterOn: [],
            sortBy: "age",
            sortDesc: false,
            fields: [
                { key: "name", label:"Nombre", sortable: true },
                { key: "email", label:"Correo Electrónico", sortable: true },
                { key: "acciones", label:"Acciones", sortable: true }
            ],
            retroalimentacion:'',
            usuario:'',
            user_evaluar:'',
            instrumento:{
                nombre: ''
            }
        };
    },
    computed: {
        /**
         * Total no. of records
         */
        rows() {
        return this.usuarios.length;
        }
    },
    mounted() {
        // Set the initial number of items
        this.totalRows = this.items.length;
    },
    methods: {
        /**
         * Search the table data with search input
         */
        onFiltered(filteredItems) {
        // Trigger pagination to update the number of buttons/pages due to filtering
        this.totalRows = filteredItems.length;
        this.currentPage = 1;
        },
        abrir_retroalimentacion(usuario){
            console.log(usuario);
            this.usuario = usuario;
            this.user_evaluar={
                id: usuario.user_id,
                nombre: usuario.nombre,
                apellidoPaterno :usuario.apellidoPaterno,
                apellidoMaterno: usuario.apellidoMaterno
            };
            this.instrumento.nombre= usuario.nombre_instrumento
            this.$refs['modal-retroalimentacion'].show()
        },
        guardar_retroalimentacion(){
            let fromData={
                usuario_id : this.usuario.user_id,
                retroalimentacion : this.retroalimentacion
            }
            axios.post('/api/guardar_retroalimentacion', fromData).then(res=>{
                if (res.data.estado) {
                    Swal.fire({
                        title: "Se ha agregado retroalimentación", 
                        //text: "Debe tomar conocimiento sobre los Documentos Institucionales y Reglamentos",
                        icon: "success",
                        confirmButtonColor: "#f1b44c",
                        confirmButtonText: "Aceptar"
                    });
                }
            });
        }
    },
    created(){
        axios.get('/api/get_retro').then(res=>{
            this.usuarios = res.data.usuarios;
        });
    }
};
</script>
<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <h4 class="card-title">Usuarios a Retroalimentar</h4>
                        <div class="row mt-4">
                            <div class="col-sm-12 col-md-6">
                                <div id="tickets-table_length" class="dataTables_length">
                                    <label class="d-inline-flex align-items-center">
                                        Mostrar&nbsp;
                                        <b-form-select v-model="perPage" size="sm" :options="pageOptions"></b-form-select>&nbsp;
                                    </label>
                                </div>
                            </div>
                            <!-- Search -->
                            <div class="col-sm-12 col-md-6">
                                <div id="tickets-table_filter" class="dataTables_filter text-md-right">
                                    <label class="d-inline-flex align-items-center">
                                        Buscar:
                                        <b-form-input
                                        v-model="filter"
                                        type="search"
                                        placeholder="Buscar..."
                                        class="form-control form-control-sm ml-2"
                                        ></b-form-input>
                                    </label>
                                </div>
                            </div>
                            <!-- End search -->
                        </div>
                        <!-- Table -->
                        <div class="table-responsive mb-0">
                            <b-table
                                :items="usuarios"
                                :fields="fields"
                                responsive="sm"
                                :per-page="perPage"
                                :current-page="currentPage"
                                :sort-by.sync="sortBy"
                                :sort-desc.sync="sortDesc"
                                :filter="filter"
                                :filter-included-fields="filterOn"
                                @filtered="onFiltered"
                            >
                                <template v-slot:cell(name)="data">
                                    <p>{{ data.item.nombre}} {{data.item.apellidoPaterno}} {{data.item.apellidoMaterno}}</p>
                                </template>
                                <template v-slot:cell(acciones)="data">
                                    <b-button size="sm" variant="primary" @click="abrir_retroalimentacion(data.item)">Retroalimentar</b-button>
                                </template>
                            </b-table>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div class="dataTables_paginate paging_simple_numbers float-right">
                                    <ul class="pagination pagination-rounded mb-0">
                                        <!-- pagination -->
                                        <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"></b-pagination>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <b-modal ref="modal-retroalimentacion" size="xl" :title="'Observaciones '+usuario.nombre+' '+usuario.apellidoPaterno+' '+usuario.apellidoMaterno" ok-title="Guardar" cancel-title="Cancelar" @ok="guardar_retroalimentacion">
                        <Jefe :user_evaluar="user_evaluar" v-if="instrumento.nombre=='Jefe de Departamento'" :retro='true'/>
                        <Profesor :user_evaluar="user_evaluar" v-else-if="instrumento.nombre=='Profesor Jefe'" :retro='true'/>
                        <Encargado :user_evaluar="user_evaluar" v-else-if="instrumento.nombre=='Encargado de Convivencia'" :retro='true'/>
                        <Docente :user_evaluar="user_evaluar" v-else-if="instrumento.nombre=='Docente'" :retro='true'/>
                        <Coordinador :user_evaluar="user_evaluar" v-else-if="instrumento.nombre=='Coordinadores'" :retro='true'/>
                        <Auxiliar :user_evaluar="user_evaluar" v-else-if="instrumento.nombre=='Auxiliar'" :retro='true'/>
                        <Asistente :user_evaluar="user_evaluar" v-else-if="instrumento.nombre=='Asistente de la Educación'" :retro='true'/>
                        <b-form-group id="example text" label="Retroalimentación" label-for="text">
                            <b-form-textarea id="textarea" v-model="retroalimentacion" placeholder="Ingresar Retroalimentación..." rows="3" max-rows="6" ></b-form-textarea>
                        </b-form-group>
                    </b-modal>
                </div>
            </div>
        </div>
    </Layout>
</template>